import * as actions from '../constants/action-types';
export const setSearchValue = value => {
  return {
    type: actions.SEARCH_PRODUCTS,
    payload: value,
  };
};
